/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Port } from './Port';
import {
    PortFromJSON,
    PortFromJSONTyped,
    PortToJSON,
} from './Port';

/**
 * 
 * @export
 * @interface CRSFHoneypot
 */
export interface CRSFHoneypot {
    /**
     * 
     * @type {string}
     * @memberof CRSFHoneypot
     */
    asset: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFHoneypot
     */
    created: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFHoneypot
     */
    found: number;
    /**
     * 
     * @type {Port}
     * @memberof CRSFHoneypot
     */
    port: Port;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFHoneypot
     */
    shared?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CRSFHoneypot
     */
    source_asset?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFHoneypot
     */
    tags: Array<string>;
}

/**
 * Check if a given object implements the CRSFHoneypot interface.
 */
export function instanceOfCRSFHoneypot(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "asset" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "found" in value;
    isInstance = isInstance && "port" in value;
    isInstance = isInstance && "tags" in value;

    return isInstance;
}

export function CRSFHoneypotFromJSON(json: any): CRSFHoneypot {
    return CRSFHoneypotFromJSONTyped(json, false);
}

export function CRSFHoneypotFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFHoneypot {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asset': json['asset'],
        'created': json['created'],
        'found': json['found'],
        'port': PortFromJSON(json['port']),
        'shared': !exists(json, 'shared') ? undefined : json['shared'],
        'source_asset': !exists(json, 'source_asset') ? undefined : json['source_asset'],
        'tags': json['tags'],
    };
}

export function CRSFHoneypotToJSON(value?: CRSFHoneypot | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asset': value.asset,
        'created': value.created,
        'found': value.found,
        'port': PortToJSON(value.port),
        'shared': value.shared,
        'source_asset': value.source_asset,
        'tags': value.tags,
    };
}

